<template> <!-- TODO: very important, before production, fix this to only be accessed by admin -->
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card>
          <v-toolbar color="light-blue" dark>
            <v-toolbar-title>Administrator</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div id="subheader">Projects</div>
          <v-data-table :headers="projectsHeaders" :items="projects" class="elevation-5">
            <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.privacy }}</td>
              <td>{{ new Date(props.item.updatedAt).toLocaleString() }}</td>
              <td>{{ new Date(props.item.createdAt).toLocaleString() }}</td>
              <td class="justify-left layout px-0">
                <v-btn icon class="mx-0" title="Delete Project" @click="deleteProject(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <div id="subheader">Users</div>
          <v-data-table :headers="usersHeaders" :items="users" class="elevation-5">
            <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ new Date(props.item.updatedAt).toLocaleString() }}</td>
              <td>{{ new Date(props.item.createdAt).toLocaleString() }}</td>
              <td class="justify-left layout px-0">
                <v-btn icon class="mx-0" title="Delete Project" @click="deleteUser(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {EventBus} from '@/event-bus.js'
  export default {
    data: () => ({
      projects: [],
      users: [],
      projectsHeaders: [
        {text: 'Name', value: 'name', align: 'left', sortable: true},
        {text: 'Privacy', value: 'privacy', align: 'left', sortable: true},
        {text: 'Last Update', value: 'updatedAt', align: 'left', sortable: true},
        {text: 'Created', value: 'createdAt', align: 'left', sortable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false}
      ],
      usersHeaders: [
        {text: 'Username', value: 'username', align: 'left', sortable: true},
        {text: 'Email', value: 'email', align: 'left', sortable: true},
        {text: 'Last Update', value: 'updatedAt', align: 'left', sortable: true},
        {text: 'Created', value: 'createdAt', align: 'left', sortable: true},
        {text: 'Actions', value: 'actions', align: 'left', sortable: false}
      ],
    }),
    methods: {
      refresh () {
        var email = this.$store.state.email;
        EventBus.$emit('start-loading');
        this.$http.get(this.$store.state.serverHttpUrl+'/allprojects?email='+email).then(
          function(response) {
            this.projects = response.data;
          }, function (err) {
            EventBus.$emit('send-notification', {text: 'Error fetching projects ('+err+')'});
        });
        this.$http.get(this.$store.state.serverHttpUrl+'/allusers?email='+email).then(
          function(response) {
            this.users = response.data;
            EventBus.$emit('stop-loading');
          }, function (err) {
            EventBus.$emit('stop-loading');
            EventBus.$emit('send-notification', {text: 'Error fetching projects ('+err+')'});
        });
      },
      deleteProject(item) {
        this.$swal({
          titleText: "Delete project \"" + item.name + "\"?",
          type: 'warning',
          showCancelButton: true,
          allowEnterKey: false,
          confirmButtonColor: '#FF5252',
          cancelButtonColor: '#33b5e5',
          confirmButtonText: 'Delete',
          customClass: 'elevation-5'
        }).then((result) => {
          if (result.value) {
            this.$http.delete(this.$store.state.serverHttpUrl+'/project?_id='+item._id+'&owner='+item.owner)
            .then(function (response) {
              EventBus.$emit('send-notification', {text: 'Project deleted successfully', color: 'success'});
              this.refresh();
            }, function (err) {
              EventBus.$emit('send-notification', {text: 'Error deleting project ('+err+')'});
            })
          }
        });
      },
      deleteUser(item) {
        this.$swal({
          titleText: "Delete user \"" + item.email + "\"?",
          type: 'warning',
          showCancelButton: true,
          allowEnterKey: false,
          confirmButtonColor: '#FF5252',
          cancelButtonColor: '#33b5e5',
          confirmButtonText: 'Delete',
          customClass: 'elevation-5'
        }).then((result) => {
          if (result.value) {
            this.$http.delete(this.$store.state.serverHttpUrl+'/user?email='+item.email)
            .then(function (response) {
              EventBus.$emit('send-notification', {text: 'User deleted successfully', color: 'success'});
              this.refresh();
            }, function (err) {
              EventBus.$emit('send-notification', {text: 'Error deleting user ('+err+')'});
            })
          }
        });
      },
    },
    created () {
      this.refresh()
    },
  }
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 20px;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Admin.vue